import React from 'react';
import { l } from '../../../lang/index.jsx';

export default function ProjectFilters({ agencies = [], selected = '', onChange, lang, uiMap }) {
    const allLabel = uiMap?.['filter-all']?.[lang] || l('filter-all', lang) || (lang === 'fr' ? 'Tous' : 'All');

    const handleClick = (value) => {
        onChange(value);
    };

    const handleKeyDown = (e, value) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onChange(value);
        }
    };

    return (
        <div className="projects-filters paragraph" role="toolbar" aria-label={allLabel}>
            {agencies.map((a, i) => {
                const value = (a === "") ? "" : a;
                const label = (a === "") ? allLabel : a;
                const isActive = ((selected ?? '').toString().toLowerCase() === value.toString().toLowerCase());

                return (
                    <button
                        key={`filter-${i}`}
                        type="button"
                        className={`projects-filter-button ${isActive ? 'is-active' : ''}`}
                        aria-label={label ? `Filter ${label}` : 'Filter projects'}
                        aria-pressed={isActive}
                        onClick={() => handleClick(value)}
                        onKeyDown={(e) => handleKeyDown(e, value)}
                    >
                        {label}
                    </button>
                );
            })}
        </div>
    );
}
